import * as React from "react"

const SvgCloseCircleFilledMini = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.5 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14m-1.917-3.7L8.5 9.375l1.9 1.925q.274.3.688.3.412 0 .712-.3a.96.96 0 0 0 .275-.704.96.96 0 0 0-.275-.704L9.875 7.975l1.925-1.9q.3-.275.3-.688t-.3-.712a.96.96 0 0 0-.704-.275.96.96 0 0 0-.704.275L8.5 6.6 6.575 4.675a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.96.96 0 0 0-.275.704q0 .428.275.704L7.1 7.975 5.175 9.9a.95.95 0 0 0-.275.7.95.95 0 0 0 .275.7.96.96 0 0 0 .704.275q.428 0 .704-.275"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCloseCircleFilledMini
